import { useCallback } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getShipmentsMetadata } from '../../use-cases/getShipmentsMetadata'

export function useGetShipmentsMetadata() {
  const { call, result, status, error } = useAsync(getShipmentsMetadata)
  const abortController = useAbortController()

  const fetchShipmentsMetadata = useCallback(
    (enableNewShipmentsEndpoint: boolean) => {
      return call({ config: { signal: abortController.signal } }, enableNewShipmentsEndpoint)
    },
    [call, abortController]
  )

  return {
    shipmentsMetadata: result,
    status,
    error,
    fetchShipmentsMetadata,
  }
}
